import { ThemeUIStyleObject } from 'theme-ui';

export const pageStyles: ThemeUIStyleObject = {
  backgroundColor: 'neutral/100',
  minHeight: '100vh',
  flexDirection: 'row',
  position: 'relative',
};

export const alphabetPanelStyles: ThemeUIStyleObject = {
  position: 'fixed',
  left: 0,
  top: '4rem', // Below InfoTrack header
  width: '4rem',
  height: 'calc(100vh - 4rem)',
  backgroundColor: 'neutral/000',
  borderRight: '1px solid',
  borderColor: 'neutral/300',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '1rem',
  overflowY: 'auto',
  zIndex: 10,
};

export const alphabetLetterStyles: ThemeUIStyleObject = {
  width: '2.5rem',
  height: '2.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  fontSize: '0.875rem',
  fontWeight: 600,
  color: 'neutral/700',
  borderRadius: '0.25rem',
  transition: 'all 0.2s ease',
  marginBottom: '0.25rem',
  
  '&:hover': {
    backgroundColor: 'neutral/100',
    color: '#0c7e96',
  },
};

export const alphabetLetterActiveStyles: ThemeUIStyleObject = {
  backgroundColor: '#0c7e96',
  color: 'neutral/000',
  
  '&:hover': {
    backgroundColor: '#0a6880',
    color: 'neutral/000',
  },
};

export const contentAreaStyles: ThemeUIStyleObject = {
  marginLeft: '4rem', // Space for alphabet panel
  flex: 1,
  minHeight: '100vh',
  flexDirection: 'column',
};

export const headerContentStyles: ThemeUIStyleObject = {
  flex: 1,
  width: '100%',
  padding: ['1rem', '2rem 5rem'],
  paddingTop: ['1rem', '1.5rem'],
};

export const listContainerStyles: ThemeUIStyleObject = {
  display: 'grid',
  gridTemplateColumns: ['1fr', '1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)'],
  gap: '1.5rem',
  marginTop: '2rem',
};

export const emptyStyles: ThemeUIStyleObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '20rem',
  backgroundColor: 'neutral/000',
  borderRadius: '0.5rem',
  padding: '2rem',
  marginTop: '2rem',
};
